module.exports = __webpack_public_path__ + "static/media/D.1352add4.png";